import React, { useState, useEffect } from "react";
import './classes/AgentSidebar.css';
 import { configData } from "../config";


const AgentSidebar = ({ userEmail, userId}) => {
  const [masquerade, setMasquerade] = useState(false);
  const [loading, setLoading] = useState(false);
    const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
    
    const app_url = configData.APP_URL;
     useEffect(() => {
        const mask = localStorage.getItem('masquerade');
        setMasquerade(mask === "1");
        }, []);
  
    useEffect(() => {   

    const handler = setTimeout(() => {
     // fetchData();
    }, 500); // Debounce for 500ms

    return () => {
      clearTimeout(handler);
    };
  });
  



    return(
        
        <div className="agent-right">
            <div id="sidebar-third" className="agent-grid_4">
                <div className="agent-region agent-region-sidebar-third">
                    <div id="block-smww-smww-operations" className="agent-block agent-block-smww"></div>
                       
                            <h1>Quick Links</h1>
                           <ul className="user-opt-menu">
                                    <li>
                                        {/* <a href={`/users/${userEmail}`}>Home</a> */}
                                        <a href={`/user/${loggedin_drupal_uid}`}>Home</a>
                                    </li>
                                    <li>
                                        <a href="/pending_athletes">Athletes Looking for an Agent</a>
                                    </li>
                                    <li>
                                        <a href="/my_athletes">My Athletes</a>
                                    </li>
                                    <li>
                                        <a href="/add_athlete">Create Athlete</a>
                                    </li>
                                    <li>
                                        <a href="/resource_library">Resource Library</a>
                                    </li>
                                    <li>
                                        <a href="/agents-directory">Agent Directory</a>
                                    </li>
                                    <li>
                                        <a href={`/user/${loggedin_drupal_uid}/edit`}>Manage My Public Profile</a>
                                    </li>
                                    <li>
                                        <a href="/my_agents_account">My Account</a>
                                    </li>
                                    </ul>
                        

                            <a style={{color:"#fff"}} href="https://smww.zoom.us/j/804154184" rel="nofollow" class="form-submit" target="_blank">Sunday Chat Link</a>
                       
                           <li className='agent-header-hello-text'><a href={"/user/"+loggedin_drupal_uid+"/edit"} className="agent-quick_link_anchor">Manage My Profile</a></li>
                                <li>
                                <a href="/smww_pay">
                                <input type="button" className='agent-quick-links-reg-button' value="Register for a Course"/>
                                </a>
                                </li>
                                     
                                           
                </div>
            </div>
        </div>
        
    );
};

export default AgentSidebar;